import React from 'react';
import PropTypes from 'prop-types';
import { FILTER_IDS } from '@src/js/constants.js';
import { useSearchParams } from 'react-router-dom';
import { SearchFilter } from '@src/components/core/core-component-imports.js';
import useBlogCategorySearch from '@src/hooks/use-blog-category-search.jsx';
import SearchResultsPageContentType from '@js/content-types/search-results-page-content-type.es6.js';

const BlogCategoryFilter = ({ open, clickHandler, selectionHandler, hidden }) => {
  const [searchParams] = useSearchParams();
  const search = searchParams.get(FILTER_IDS.SEARCH);

  const searchResultsPage = new SearchResultsPageContentType();
  const filterLabel = searchResultsPage.blogCategoryFilterLabel.item.$(0).text();
  const applyFilterLabel = searchResultsPage.applyFilterLabel.item.$(0).text();
  const clearLabel = searchResultsPage.clearLabel.item.$(0).text();
  const searchPlaceholder = searchResultsPage.searchPlaceholder.item.$(0).text();

  const { loading, error, response: categories } = useBlogCategorySearch({ search, immediate: true });

  const getOptions = () => {
    let options = {};
    categories?.forEach(category => {
      if (category['field_category']) {
        options[category['field_category']] = {
          label: category['field_category'],
        };
      }
    });
    return options;
  };

  const options = getOptions();

  return (
    <SearchFilter
      name={filterLabel}
      queryParameterName={FILTER_IDS.BLOG_CATEGORY}
      disabled={loading || error}
      options={options}
      open={open}
      clickHandler={clickHandler}
      selectionHandler={selectionHandler}
      applyFilterLabel={applyFilterLabel}
      clearLabel={clearLabel}
      searchPlaceholder={searchPlaceholder}
      allowSearch={false}
      hidden={hidden || options.length === 0}
    />
  );
}

BlogCategoryFilter.propTypes = {
  /**
   *  determines if the filter is active for user selection (when true) or closed (when false)
   */
  open: PropTypes.bool.isRequired,
  /**
   * the callback function for when the filter button is clicked
   */
  clickHandler: PropTypes.func.isRequired,
  /**
   * the callback function for when a selection is made
   */
  selectionHandler: PropTypes.func.isRequired,
  /**
   * controls whether the dropdown should be visually disabled and unable to be clicked
   */
  disabled: PropTypes.bool,
  /**
   * controls whether dropdown is visible or hidden
   */
  hidden: PropTypes.bool,
};

export default BlogCategoryFilter
